module.exports = __webpack_public_path__ + "img/weather-rainsnow.d1da0448.png";